exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n/deep/ .toast{\n    width: 50%!important;\n    height: 154px!important;\n    margin: auto!important;\n    text-align: center;\n}\n\n/deep/ #toast-container{\n    width: 100%!important;\n}\n\n/deep/ .toast-title{\n    font-size: 22px!important;\n}\n.containerbackground{\n    background:#e8e8e8;\n    width: 100%;\n    margin: 0 auto;\n    min-height: calc(100vh - 0px);\n    background-size: cover;\n    text-align: center;\n    padding-left: 0px;\n    padding-right: 0px;\n}\n.mega{\n    border: 1px #34495e solid;\n    border-radius:0px;\n    background-color:#FFFFFF;\n    padding: 80px 0;\n\n}\n/deep/.customClass {\nbackground-color: #e8e8e8;\n}\n\n/deep/.customClass .img-ul-upload {\n    background-color: #000 !important;\n}\n\n/deep/.customClass .img-ul-clear {\n    background-color: #B819BB !important;\n    display:none !important;\n    \n}\n\n/deep/.customClass .img-ul-drag-box-msg {\n    color: #000000 !important;\n}\n\n/deep/.customClass .img-ul-container {\n    background-color: #e8e8e8 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = 141
// module chunks = 0